import { Card, CardHeader, CardTitle, CardDescription } from "./ui/card";

const providers = [
  {
    name: "OpenAI",
    logo: "/openai.svg",
    description:
      "Cutting-edge language models for advanced penetration testing.",
    website: "https://openai.com",
    dimensions: { width: 32, height: 32 },
  },
  {
    name: "Anthropic",
    logo: "/anthropic.svg",
    description: "Ethical AI solutions for secure and responsible testing.",
    website: "https://anthropic.com",
    dimensions: { width: 92, height: 32 },
  },
  {
    name: "DeepInfra",
    logo: "/deepinfra.svg",
    description: "The fastest ML Inference for AI-powered penetration testing.",
    website: "https://deepinfra.com",
    dimensions: { width: 48, height: 48 },
  },
  {
    name: "OpenRouter",
    logo: "/openrouter.svg",
    description: "The newest LLM models for AI-powered penetration testing.",
    website: "https://openrouter.ai",
    dimensions: { width: 48, height: 48 },
  },
];

export default function Providers() {
  return (
    <section id="providers" className="py-20 bg-muted/50">
      <div className="container mx-auto">
        <h2 className="text-3xl font-bold mb-12 text-center">
          AI Service Providers
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {providers.map((provider, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader className="space-y-6">
                <a
                  href={provider.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full hover:opacity-80 transition-opacity"
                >
                  <div className="h-20 w-full flex items-center justify-center p-4">
                    <div className="relative w-full h-full flex items-center justify-center">
                      <img
                        src={provider.logo}
                        alt={`${provider.name} logo`}
                        width={provider.dimensions.width}
                        height={provider.dimensions.height}
                        className="dark:invert items-center justify-center"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          objectFit: "contain",
                          width: "auto",
                          height: "auto",
                        }}
                      />
                    </div>
                  </div>
                </a>
                <div className="space-y-2">
                  <CardTitle className="text-center">{provider.name}</CardTitle>
                  <CardDescription className="text-center">
                    {provider.description}
                  </CardDescription>
                </div>
              </CardHeader>
            </Card>
          ))}
        </div>
        <p className="text-center text-muted-foreground mt-8">
          Configure your preferred AI provider in the settings
        </p>
      </div>
    </section>
  );
}
